<template>
  <div class="articles-content articles-content--gutters"  itemscope itemtype="http://schema.org/Article">
    <!-- <pre>{{data}}</pre> -->
    <article-header :data="data" v-if="!plugin" />
    <div v-else class="px-md-9 px-0">
      <h1 class="article-header__title my-9" itemprop="headline">{{data.title}}</h1>
      <img class="article-header__head_img mb-9" width="100%" ref="headerImage" v-if="data.head_img !== 'null'" :src="`/uploads${data.head_img}`" :alt="data.title">
    </div>

    <article-content :data="data" />
    <div class="button__block__plugin px-md-9 px-0" v-if="data.plugin && data.plugin.link">
      <div class="buttons__plugins d-flex flex-column justify-start">
        <div v-for="(link, index) in JSON.parse(data.plugin.link)" :key="index" class="d-flex mt-6 mb-9">
          <div class="align-self-center mr-6" v-if="link.descText">{{link.descText}}</div>
          <a
            target="_blank"
            rel="nofollow"
            :href="link.link"
            @click="logDownloadPlugin({
              plugin_id: data.plugin.id,
              post_content_id: data.plugin.post_content_id,
              post_record_id: data.post_record_id,
            })"
          >
            <bim-button>{{link.buttonText}}</bim-button>
          </a>
        </div>
      </div>
    </div>
    <span v-if="!plugin" class="article-hr"></span>
    <BannerPlugin v-if="!plugin && (data.section_type==='buildingsmart' || data.section_type==='projects')" class="mx-md-9 mx-0 my-9" />
    <article-similar v-if="!plugin" :article_id="data.content_id" />
  </div>
</template>

<script>
import articleHeader from './Header'
import articleContent from './Content'
import articleComments from './Comments'
import articleSimilar from './SimilarMaterial'
import BannerPlugin from "../BannerPlugin"
import { logDownloadPlugin } from "@/utils/logEvents"

  export default {
    components: {
      articleHeader,
      articleContent,
      articleSimilar,
      BannerPlugin,
    },
    props: {
      data: {
        type: Object,
        required: true
      },
      plugin: {
        type: Boolean,
        default: false
      },
    },
    methods: {
      logDownloadPlugin,
    }
  }
</script>

<style lang="scss" scoped>

</style>
